// Phones: the hero's Call / quote bar follows the customer down the page once the hero's own buttons have gone off the
// top, and steps aside while they type. It lines up with Shopify Inbox's Chat button (same height and bottom, beside
// it), measured from the app's open shadow root; without the app it spans the screen.
(() => {
  const GAP = 8;
  const FIELD = 'input:not([type="checkbox"], [type="radio"], [type="submit"], [type="button"], [type="hidden"]), textarea, select';
  const bars = [...document.querySelectorAll('[data-sticky-actions]')];
  if (!bars.length) return;

  const chatButton = () => document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button.activator');

  const place = () => {
    const chat = chatButton();
    const host = chat && chat.getRootNode().host.getBoundingClientRect();
    const r = chat && chat.getBoundingClientRect();
    if (!r || !r.width) return;
    const onLeft = r.left + r.width / 2 < host.width / 2;
    for (const bar of bars) {
      bar.style.setProperty('--sticky-left', `${onLeft ? r.right + GAP : host.width - r.right}px`);
      bar.style.setProperty('--sticky-right', `${onLeft ? r.left : host.width - r.left + GAP}px`);
      bar.style.setProperty('--sticky-bottom', `${host.bottom - r.bottom}px`);
      bar.style.setProperty('--sticky-height', `${r.height}px`);
    }
  };

  // The app loads after the page and builds its button inside its shadow root, then animates it in, so this measures
  // again whenever the bar is about to show
  const resize = new ResizeObserver(place);
  const found = () => {
    const chat = chatButton();
    if (chat) resize.observe(chat);
    return Boolean(chat);
  };
  if (!found()) {
    const watch = new MutationObserver(() => {
      const root = document.querySelector('shopify-chat')?.shadowRoot;
      if (root) watch.observe(root, { childList: true, subtree: true });
      if (found()) watch.disconnect();
    });
    watch.observe(document.body, { childList: true });
  }
  window.addEventListener('resize', place);

  // Checked on scroll rather than with an IntersectionObserver, which misses a jump straight past the hero's buttons
  // (an anchor link or a fling) because they never come into view on the way
  const header = document.querySelector('.section-header');
  const headerHeight = header ? header.offsetHeight : 0;
  const items = bars
    .map((bar) => ({ bar, trigger: bar.closest('section')?.querySelector('[data-sticky-trigger]'), past: false }))
    .filter((item) => item.trigger);
  let typing = false;

  const update = () => {
    for (const item of items) {
      const past = item.trigger.getBoundingClientRect().bottom < headerHeight;
      if (past && !item.past) place();
      item.past = past;
      item.bar.classList.toggle('is-visible', past && !typing);
    }
  };
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      update();
    });
  };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('focusin', (event) => {
    if (!event.target.matches?.(FIELD)) return;
    typing = true;
    update();
  });
  document.addEventListener('focusout', () => {
    typing = false;
    update();
  });
  items.forEach((item) => (item.bar.hidden = false));
  update();
})();
